export default __webpack_public_path__ + "static/media/photo--lg--138.c260e647.jpg";